// extracted by mini-css-extract-plugin
export default {"logo":"Login_logo__j1HlC","login":"Login_login__dH0gZ","form":"Login_form__iHhDl"};